/* eslint-disable */
<template>
    <div id="app">
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
        <link rel='stylesheet' type='text/css' href='jquery.weekcalendar.css' />
        <div class="booking-container">
          <BookingFlow />
        </div>
    </div>
</template>

<script>
import Pagination from './components/Pagination.vue'
import Datepicker from 'vuejs-datepicker';
import Dropdown from 'v-select2-component';
import axios from 'axios';
import BookingFlow from "./components/questions/BookingFlow.vue";

export default {
    name: 'app',
    components: {
        BookingFlow,
        Pagination,
        Datepicker,
        Dropdown
        //Calendar
    },
    data: function() {
        return {
            loading: false,
            submitError: '',
            step: 1,
            total: 4,
            serviceData: {},
            category: {},
            service: {},
            calErrors: [],
            clientData: [],
            corporateClass: false,
            times: [
                {id : '09:00', text: '09:00 - 09:30'},
                {id : '09:30', text: '09:30 - 10:00'},
                {id : '10:00', text: '10:00 - 10:30'},
                {id : '10:30', text: '10:30 - 11:00'},
                {id : '11:00', text: '11:00 - 11:30'},
                {id : '11:30', text: '11:30 - 12:00'},
                {id : '12:00', text: '12:00 - 12:30'},
                {id : '12:30', text: '12:30 - 13:00'},
                {id : '13:00', text: '13:00 - 13:30'},
                {id : '13:30', text: '13:30 - 14:00'},
                {id : '14:00', text: '14:00 - 14:30'},
                {id : '14:30', text: '14:30 - 15:00'},
                {id : '15:00', text: '15:00 - 15:30'},
                {id : '15:30', text: '15:30 - 16:00'},
                {id : '16:00', text: '16:00 - 16:30'},
                {id : '16:30', text: '16:30 - 17:00'},
                {id : '17:00', text: '17:00 - 17:30'}
            ],
            time: '',
            date: '',
            formattedDate: '',
            errors : [],
            selectSettingsTime: {
                minimumResultsForSearch: -1,
                placeholder: 'Select a time.',
                dropdownAutoWidth : true
            },
            disabledDates: {
                days: [6, 0],
                dates: []
            }
        }
    },
    methods: {
        show: function() {
            this.step = 3;
            var app = document.getElementById('app');
            //app.dispatchEvent('build');
            //app.dispatchEvent(new Event('build'));
        },
        goBack: function() {
            if (this.step > 1) {
              this.step--;
            }
        },
        nextStep: function(step) {
            this.errors = [];
            if(step == 3) {
              console.log(this.category);
                if(Object.keys(this.category).length === 0 || Object.keys(this.service).length === 0) {
                    if(Object.keys(this.category).length === 0) {
                        this.errors.push('Please select a category.');
                    }
                    if(Object.keys(this.service).length === 0) {
                        this.errors.push('Please select type.');
                    }
                } else {
                    this.step = 3;
                    this.errors = '';
                    this.renderBookingCalendar();
                }
            }
        },
        renderBookingCalendar: function () {
          var year = new Date().getFullYear();
          var month = new Date().getMonth();
          var day = new Date().getDate();
          var bookings = [];
          setTimeout(function() {
            $('#calendar').weekCalendar({
              data: window.location.protocol + '//' + window.location.host + '/wp-json/bookings/v1/booking-list/',
              date: new Date(),
              daysToShow: 5,
              timeslotsPerHour: 2,
              use24Hour: true,
              height: function($calendar) {
                return $(window).height() - $('h1').outerHeight() - $('.description').outerHeight();
              },
              eventRender: function(calEvent, $event) {
                if (calEvent.end.getTime() < new Date().getTime()) {
                  $event.css('backgroundColor', '#aaa');
                  $event.find('.time').css({
                    backgroundColor: '#999',
                    border: '1px solid #888'
                  });
                }
              },
              calendarAfterLoad: function(calendar) {
                var calHeight = $('.wc-header').height() + $('.wc-toolbar').height();
                var calMainHeight = $('.wc-scrollable-grid').height() - calHeight;
                $('.wc-scrollable-grid').height(calMainHeight);
              },
              eventNew: function(calEvent, $event) {
                var genId = 'n' + calEvent.start.getTime();
                $event[0].id = genId;
                calEvent.id = genId;
                var start = Math.round(new Date(calEvent.start).getTime() / 1000);
                var end = Math.round(new Date(calEvent.end).getTime() / 1000);
                var now = new Date().getTime() / 1000;
                if(start < now) {
                  alert('Please book an appoitment in the future.');
                  $event[0].remove();
                } else {
                  function timeConverter(UNIX_timestamp, type) {
                    var a = new Date(UNIX_timestamp * 1000);
                    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    var year = a.getFullYear();
                    var month = months[a.getMonth()];
                    var date = a.getDate();
                    var hour = a.getHours();
                    var min = a.getMinutes();
                    if (min == 0) {
                      min = '00';
                    }
                    var sec = a.getSeconds();
                    if (type == 'start') {
                      var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
                    } else {
                      var time = hour + ':' + min;
                    }
                    return time;
                  }
                  var startDate = timeConverter(start, 'start');
                  var endDate = timeConverter(end, 'end');
                  $('.summary-container').show();
                  $('.booking-list').prepend('<li data-start="'+ calEvent.start.getTime() +'" data-end="'+ calEvent.end.getTime() +'" id="' + genId + '"><div class="booking-time">' + startDate + ' - ' + endDate + '</div><div class="booking-price">£29.50 <span>(to pay on arrival)</span></div><div class="remove"><i class="fas fa-times"></i></div></li>');


                  var singleBooking = {};
                  singleBooking.id = calEvent.id;
                  singleBooking.start = calEvent.start.getTime();
                  singleBooking.end = calEvent.end.getTime();
                  bookings.push(singleBooking);
                }
              },
              eventClick: function(calEvent, $event) {
                var newBookings = [];
                if (!calEvent.rendered) {
                  $event[0].remove();
                }
                var bookingId = $event[0].id;
                if($('.booking-list li').length > 0) {
                  $('.booking-list li#' + bookingId).remove();
                }
              },
            });
          }, 1000);
        },
        emitCategoryParent: function(category) {
            this.category = category.id;
        },
        emitServiceParent: function(service) {
            this.service = service;
        },
        emitToggleEventParent: function(event) {
            if(event.value) {
                this.corporateClass = true;
            }
        },
        emitClientDataFormParent: function(clientData) {
            this.clientData = clientData;
            this.step = 2
        },
        emitGoBackSubmitParent:function() {
            this.step = 1
        },
        submitBooking: function() {
            var bookingList = document.getElementById("booking-list").children;
            var bookingArray = [];
            var self = this;

            if(bookingList.length > 0) {
                this.loading = true;
                for (var i = bookingList.length - 1; i >= 0; i--) {
                    var singleBooking = bookingList[i];
                    var b = {};
                    b.id = singleBooking.getAttribute('id');
                    b.start = singleBooking.getAttribute('data-start');
                    b.end = singleBooking.getAttribute('data-end');
                    b.service = this.service.text;
                    b.category = this.category.text;
                    b.clientData = this.clientData;

                    // Send over a DateTime
                    let startDateTime = new Date(0);
                    startDateTime.setUTCSeconds(parseInt(singleBooking.getAttribute('data-start')) / 1000);

                    let minutes = startDateTime.getMinutes();
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    let month = (startDateTime.getMonth() + 1);
                    month = month < 10 ? '0' + month : month;
                    b.startDateTime = startDateTime.getFullYear() + "-" + month + "-" + startDateTime.getDate() + " " + startDateTime.getHours() + ':' + minutes + ':00';

                    var diff = parseInt(b.start) - new Date().getTime();
                    if(diff > 0) {
                        bookingArray.push(b);
                    }
                }
                // send to axios

                axios.post(window.location.protocol + '//' + window.location.host + '/wp-json/booking/v1/submit-list/',  {
                    bookings:  bookingArray
                },
                {
                    headers: {
                        'Content-type': 'application/x-www-form-urlencoded',
                    }
                }).then(function(response) {
                    if(response.data == false) {
                        self.loading = false;
                        self.submitError = 'Sorry there has been an error with your booking please refresh the page and start again.';
                    } else {
                        window.location.replace(window.location.protocol + '//' + window.location.host + '/booking/thank-you');
                    }
                });
            } else {
                this.calErrors.push('Please select a date and time');
            }
        },
        addSession() {
            this.calErrors = [];
            if(!this.formattedDate) {
                this.calErrors.push('Please select a date');
            }
            if(!this.time) {
                this.calErrors.push('Please select a time');
            }
            if(this.calErrors.length == 0) {
                var datum = Date.parse(this.formattedDate + ' ' + this.time);
                var datum2 = (datum / 1000) + 3600;
                var now = Date.now() / 1000;
                var datum3 = (datum2 - 3600) * 1000;
                var datum4 = (datum2 - 1800) * 1000;
                function timeConverter(UNIX_timestamp, type) {
                    var a = new Date(UNIX_timestamp);

                    var monthsT = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    var yearT = a.getFullYear();
                    var monthT = monthsT[a.getMonth()];
                    var dateT = a.getDate();
                    var hourT = a.getHours();
                    var minT = a.getMinutes();
                    if (minT == 0) {
                        minT = '00';
                    }
                    var sec = a.getSeconds();
                    if (type == 'start') {
                        var timeT = dateT + ' ' + monthT + ' ' + yearT + ' ' + hourT + ':' + minT;
                    } else {
                        var timeT = hourT + ':' + minT;
                    }
                    return timeT;
                }

                var startDate = timeConverter(datum3, 'start');
                var endDate = timeConverter(datum4, 'end');

                if(datum2 < now) {
                    alert('Please select a time that is in the future.');
                } else {
                    axios.get(window.location.protocol + '//' + window.location.host + '/wp-json/bookings/v1/booking-list/')
                    .then(function (response) {
                        var data = response.data;
                        for (var i = data.length - 1; i >= 0; i--) {
                            var existingDate = data[i].start;
                            var existingDateEnd = data[i].end;
                            existingDate = Date.parse(existingDate) / 1000;
                            existingDateEnd = Date.parse(existingDateEnd) / 1000;
                            if(data[i].type == 'client') {
                                if(existingDate <= (datum2 - 3600) && (datum2 - 3600) <= existingDateEnd) {
                                    alert('There are no avaliable appointments at this time.');
                                    return;
                                }
                            } else {
                                if(existingDate == datum2 - 3600) {
                                    alert('There are no avaliable appointments at this time.');
                                    return;
                                }  else {
                                    $('.summary-container').show();
                                }
                            }
                        }
                        if($('#booking-list li').length > 0) {
                            $('#booking-list li').each(function() {
                                var start  = $(this).attr('data-start') / 1000;
                                var weekEnd = start + ((3600 * 24) * 7);
                                var weekStart = start - ((3600 * 24) * 7);
                                var picked = datum2 - 3600;
                                if(start !== picked) {
                                     $('.booking-list').prepend('<li data-start="'+ datum3+'" data-end="'+ datum4+'"><div class="booking-time">' + startDate + ' - ' + endDate + '</div><div class="booking-price">£29.50 <span>(to pay on arrival)</span></div><div class="remove"><i class="fas fa-times"></i></div></li>');
                                } else {
                                    alert('Please select a different time.');
                                    return;
                                }
                            });
                        } else {
                            $('.booking-list').prepend('<li data-start="'+ datum3+'" data-end="'+ datum4+'"><div class="booking-time">' + startDate + ' - ' + endDate + '</div><div class="booking-price">£29.50 <span>(to pay on arrival)</span></div><div class="remove"><i class="fas fa-times"></i></div></li>');
                        }
                    })
                    .catch(function () {

                    });
                }
            }
        },
        selectDate(date) {
            this.disabledDates.dates.push(new Date(date));
            var thisDate = new Date(date);
            var thisYear = thisDate.getFullYear();
            var thisMonth = thisDate.getMonth();
            var thisDay = thisDate.getDate();
            var month = new Array();
                month[0] = "January";
                month[1] = "February";
                month[2] = "March";
                month[3] = "April";
                month[4] = "May";
                month[5] = "June";
                month[6] = "July";
                month[7] = "August";
                month[8] = "September";
                month[9] = "October";
                month[10] = "November";
                month[11] = "December";

            thisMonth = month[thisDate.getMonth()];

            this.formattedDate = thisDay + ' ' + thisMonth + ' ' + thisYear;
        }
    },
    mounted: async function () {
        var self = this;
        //window.location.protocol + '//' + window.location.host + '/wp-json/categories/v1/category-list/'
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

        if(!isIE11) {
            var urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('cat')) {
                var chosenCat = urlParams.get('cat');
                self.serviceData.selectedCat = chosenCat;
            }
            if(urlParams.has('type')) {
                var chosenType = urlParams.get('type');
                self.serviceData.selectedType = chosenType;
            }
        } else {
            self.serviceData.selectedCat = '';
            self.serviceData.selectedType = '';
        }

        const response = await axios.get("/wp-json/categories/v1/category-list/");
        this.serviceData.categoryList = response.data;
        this.serviceData.fullList = response.data;
        this.$set(this.serviceData);
    }
}
</script>

